import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchProjects, deleteProject } from '../../actions/project';
import IconDocumentStatus from "../partials/IconDocumentStatus";



class ProjectItem extends React.Component {

  handleDelete(elm) {
    var result = window.confirm("Voulez vous vraiment supprimer ce projet?");
    if (result) {
      this.props.deleteProject(this.props.id)
    }
  }

  UNSAFE_componentWillReceiveProps(NextProps) {
    if (NextProps.message === 'Project successfully removed!') {
      this.props.fetchProjects();
    }
  }

  renderCircle(title) {
    
    return <>             
              <IconDocumentStatus style={{marginRight: "10px", height: "20px", width: "20px", display: "inline-block"}}
                                  progression={this.props.progression}
                                  validationInformation={this.props.validationInformation}
                                  infovisible="false"
                                  kind="project"
                                  isincompleted={this.props.isincompleted}
                                  translate={this.props.translate}
              />   
            </>;


  }

  renderListProjet(title) {


        return (           
                  <IconDocumentStatus style={{marginRight:"10px", marginLeft:"10px"}}
                                      progression={this.props.progression}
                                      validationInformation={this.props.validationInformation}
                                      infovisible="false"
                                      kind="project"
                                      isincompleted={this.props.isincompleted}
                                      translate={this.props.translate}
                  /> );
  }


  renderdate(){
    return(
      <>
        {this.props.information["start-date"] ? this.props.information["start-date"].slice(3,6).concat('', this.props.information["start-date"].slice(-2)) : ""}
        {this.props.information["start-date"] && this.props.information["end-date"] ? "-" : ""} 
        {this.props.information["end-date"] ? this.props.information["end-date"].slice(3,6).concat('', this.props.information["end-date"].slice(-2)) : ""}
      </>);
  }

  filterTitleLong(title){
    var title_bis = title;
    if (title.length > 59 ) {
      title_bis = title_bis.substring(0,59) + "...";
    }
    return (title_bis);
  }

  filterTitleLongMyProfile(title){

    if (title === '(Sans titre)'){
      return (title);
    }
    var title_bis = title;
    var size = this.measureTextLongPx(title);
    if (size > 0 ) {
      //alert(size);
      title_bis = title_bis.substring(0,size) + "...";
    }
    if (size === 0) {
      title_bis = title_bis.substring(0,10) + "...";
    }
    return (title_bis);
  }


  measureTextLongPx(str) {
    var long_total = 0;
    var alphabet = ['a','z','e','r','t','y','u','i','o','p','q','s','d','f','g','h','j','k','l','m','w','x','c','v','b','n','A','Z','E','E','R','T','Y','U','I','O','P','Q','S','D','F','G','H','J','K','L','M','W','X','C','V','B','N','0','1','2','3','4','5','6','7','8','9','-','*','/','.','+','&','_','@','=',' ',''];
    var alphabet_long = [150,138,155,119,111,154,164,73,165,163,165, 128, 165, 101 , 153 , 164 , 75 , 155 , 73 , 243 , 230,151,139,154,165,164,204,185,171,189,177    ,189,215,87,238, 181   ,238,159,223,167,218,223,131,202     ,152,272,306,193,204,204,190,223,174,170,172,172,174,172,172,173,172,172,102,118,94,84,172,210,119,245,171,70,0];
    var alphabet_minimal = 100;

    for (let i = 0; i < str.length; i++) {
      for (let y = 0 ; y <alphabet.length ; y++) {
        if (str[i] === alphabet[y]){
          long_total = long_total + alphabet_long[y] ;
          if (y === alphabet[-1]){
            long_total = long_total + alphabet_minimal ;
          }
          if (long_total > 1350) {
            return(i);
          }
        }
      }
    }
    return(0);
  }

  circleColor(){
    var color = '#989DA3'
    if (this.props.progression > 0) {
      color = '#CF3440'
    }
    if (this.props.progression > 25) {
      color = '#CF8B44'
    }
    if (this.props.progression > 50) {
      color = '#CFC544'
    }
    if (this.props.progression > 75) {
      color = '#99CC66'
    }
    color = '' + color + '';
    return(color);
  }



  render() {


    const currentUser = JSON.parse(localStorage.getItem("user"));

    var color = '#989DA3'

    color = this.circleColor();

    var title = this.props.title
    if (title === "") {
      title = "(Sans titre)"
    }

    return (
      
      <li className="line">
        

        {!this.props.small && !this.props.circle ? (
          
          <div className="line">
            <Link to={this.props.endpoint + this.props.id}>  
            <div style={{display:"inline-block", width:"auto"}}>{this.renderListProjet(title)}</div>
            <div style={{display:"inline-block", width:"auto"}}>{this.filterTitleLong(title)}</div> 
            <div className="tools" >
              <div style={{display:"inline-block", width:"auto", marginRight:"10px"}}>{this.renderdate()}</div>
              <div style={{display:"inline-block",marginRight:"10px"}}>{" - "}</div>
              <div className="progression">
                <div className="progression-value" style={{ width: this.props.progression + "%", backgroundColor: color }}/>
              </div>
            </div>
            {currentUser ?
              <>
                {this.props.deletepermission ? (
                  <div onClick={this.handleDelete.bind(this)} style={{ position: "absolute", marginLeft: "-30px", marginTop: "-30px" }} ><i className="fas fa-trash"></i>
                  </div>
                )
                  :
                  null
                }
              </>
              :
              null
            }
            </Link>
          </div>
        ) : (
          null
        )}
        {!this.props.small && this.props.circle && this.props.information ? (
          <div className="line">
            <Link to={this.props.endpoint + this.props.id}>  
            <div  style={{display:"inline-block", width:"auto"}}>{this.renderCircle(title)}</div>
            <div  style={{display:"inline-block", width:"auto"}}>{this.filterTitleLongMyProfile(title)}</div> 
            <div  style={{display:"inline-block", width:"auto"}}> {this.renderdate()}</div>
            </Link>
          </div>
        ) : (
          null
        )}
      </li>
    );

  }
}

function mapStateToProps(state) {
  return {
    message: state.project.message
  };
}

export default connect(mapStateToProps, { fetchProjects, deleteProject })(ProjectItem);
